import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-massive-error-generic-modal',
  templateUrl: './massive-error-generic-modal.component.html',
  styleUrls: ['./massive-error-generic-modal.component.scss'],
})
export class MassiveErrorGenericModalComponent implements OnInit {
  submit: Subject<any>;
  constructor(private modalRef: BsModalRef) {
    this.submit = new Subject();
  }
  MainTextError = '';
  explanationText = '';
  showDownloadUrl = false;
  ngOnInit(): void {}

  close() {
    this.submit.next('closed');
    this.modalRef.hide();
  }
}
